import { formatMoney } from '../helpers/decimal';

const formatValue = (value) => {
  return formatMoney(value, { precision: 8 });
};

export default formatValue;
